import { Type } from "class-transformer";
import { observable } from "mobx";
import AccountBalanceCheckRequestPermittedActionsResponse from "./accountBalanceCheckRequestPermittedActionsResponse";
import AccountBalanceCheckRequestStatus from "./accountBalanceCheckRequestStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountBalanceCheckRequestResponse {
  @observable
  id!: string;

  @observable
  accountingPeriodTo!: string;

  @observable
  status!: AccountBalanceCheckRequestStatus;

  @observable
  createdAt!: string;

  @observable
  createdBy?: string;

  @observable
  @Type(() => AccountBalanceCheckRequestPermittedActionsResponse)
  permittedActions!: AccountBalanceCheckRequestPermittedActionsResponse;
}
